import Header from '@/components/header/Header.vue';
import Initializer from '@/components/initializer/Initializer.vue';

export default {
  data() {
    return {
      loading: true,
    };
  },
  components: {
    'app-header': Header,
    initializer: Initializer,
  },
};



// WEBPACK FOOTER //
// ./src/components/app/App.js